var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_8925)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_650_8925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 44,
    width: 18,
    height: 10,
    rx: 5,
    fill: "url(#paint0_linear_650_8925)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_650_8925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint1_linear_650_8925)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_650_8925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint2_linear_650_8925)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 31.4L33.6472 35L42 27",
    stroke: "#FAFBFD",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_650_8925",
    x: 6,
    y: 24,
    width: 58,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_650_8925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_650_8925",
    x: -5,
    y: -8,
    width: 83,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_650_8925"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.803922 0 0 0 0 0.87451 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_650_8925"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.997917 0 0 0 0 0.979167 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_650_8925",
    result: "effect2_dropShadow_650_8925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_650_8925",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_650_8925",
    x: 18,
    y: 14,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_650_8925"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_650_8925",
    x1: 35,
    y1: 44,
    x2: 35,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#3BFC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E38C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_650_8925",
    x1: 36,
    y1: 15.1613,
    x2: 36,
    y2: 48.9355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_650_8925",
    x1: 36,
    y1: 14,
    x2: 36,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#3BFC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E38C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_8925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8848c586b474cb0cdcb00a65ad21be3f.svg";
export { ForwardRef as ReactComponent };